<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <!-- Détails du marchand -->
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Détails emplacement</h4>
            <router-link to="/liste-emplacement" class="btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour
            </router-link>
          </div>
          <div class="d-flex flex-wrap mb-4">
  <div class="col-md-6 mb-3">
    <h5 class="fw-bold">Locataire</h5>
    <div class="d-flex align-items-center">
      <!-- Photo Locataire -->
      <div>
        <div v-if="locataireMedia.length > 0" class="mb-3">
          <img v-for="media in locataireMedia" :key="media.nomMedia"
            :src="getUrlApiForFiles('Usagers', media.nomMedia)"
            alt="Photo Locataire"
            class="img-thumbnail rounded me-2 shadow"
           style="width: 170px; height: 170px; cursor: pointer;"
            @click="openModal(media.nomMedia)"
          />
        </div>
      </div>

      <!-- Informations Locataire sous forme de tableau -->
      <div class="ms-1">
        <table class="table table-sm">
          <tbody>
            <tr>
              <td ><strong>Nom:</strong></td>
              <td>{{ emplacement?.locataire?.nom }} {{ emplacement?.locataire?.prenom }}</td>
            </tr>
            <tr>
              <td><strong>NPI:</strong></td>
              <td>{{ emplacement?.locataire?.npi }}</td>
            </tr>
            <tr>
              <td><strong>IFU:</strong></td>
              <td>{{ emplacement?.locataire?.ifu }}</td>
            </tr>
            <tr>
              <td><strong>Téléphone:</strong></td>
              <td>{{ emplacement?.locataire?.tel}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Activité Locataire sous la photo -->
    <p><strong>Activité:</strong> {{ emplacement?.locataire?.activite }}</p>
  </div>

  <!-- Section Exploitant -->
  <div class="col-md-6 mb-3">
    <h5 class="fw-bold">Exploitant</h5>
    <div class="d-flex align-items-center">
      <!-- Photo Exploitant -->
      <div>
        <div v-if="exploitantMedia.length > 0" class="mb-3">
          <img v-for="media in exploitantMedia" :key="media.nomMedia"
            :src="getUrlApiForFiles('Usagers', media.nomMedia)"
            alt="Photo Exploitant"
            class="img-thumbnail rounded me-2 shadow"
            style="width: 170px; height: 170px; cursor: pointer;"
            @click="openModal(media.nomMedia)"
          />
        </div>
      </div>

      <!-- Informations Exploitant sous forme de tableau -->
      <div class="ms-3">
        <table class="table table-sm">
          <tbody>
            <tr>
              <td><strong>Nom:</strong></td>
              <td>{{ emplacement?.exploitant?.nom }} {{ emplacement?.exploitant?.prenom }}</td>
            </tr>
            <tr>
              <td><strong>NPI:</strong></td>
              <td>{{ emplacement?.exploitant?.npi }}</td>
            </tr>
            <tr>
              <td><strong>IFU:</strong></td>
              <td>{{ emplacement?.exploitant?.ifu }}</td>
            </tr>
            <tr>
              <td><strong>Téléphone:</strong></td>
              <td>{{ emplacement?.exploitant?.tel }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Activité Exploitant sous la photo -->
    <p><strong>Activité:</strong> {{ emplacement?.exploitant?.activite }}</p>
  </div>
</div>


          <div class="row">
            <div class="col-md-6">
              <table class="table">
                <tbody>
                  <tr>
                    <td><strong>Ancien Code:</strong></td>
                    <td>{{ emplacement?.ancienne_ref }}</td>
                  </tr>
                  <tr>
                    <td><strong>Nouveau Code:</strong></td>
                    <td>{{ emplacement?.ncode_emp }}</td>
                  </tr>
                  <tr>
                    <td><strong>Taxe mensuelle:</strong></td>
                    <td>{{ emplacement?.montant_location }} F CFA</td>
                  </tr>
                  <tr>
                    <td><strong>Secteur:</strong></td>
                    <td>{{ emplacement?.secteur?.libelle_secteur || "Non défini" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
              <table class="table">
                <tbody>
                  <tr>
                    <td><strong>Locataire:</strong></td>
                    <td>{{ emplacement?.locataire?.full_name }}</td>
                  </tr>
                  <tr>
                    <td><strong>Exploitant:</strong></td>
                    <td>{{ emplacement?.exploitant?.full_name }}</td>
                  </tr>
                  <tr>
                    <td><strong>Type Emplacement:</strong></td>
                    <td>{{ emplacement?.type_emplacement?.libelleTypeEmp || "Non défini" }}</td>
                  </tr>
                  <tr>
                    <td><strong>Activité:</strong></td>
                    <td>{{ emplacement?.locataire?.activite }}</td>
                  </tr>
                
                </tbody>
              </table>
            </div>

            <div class="col-md-12">
              <table class="table">
                <tbody>
              <tr>
                    <td><strong>Plus de détail activité:</strong></td>
                    <td>{{ emplacement?.locataire?.new_activite }}</td>
                  </tr>
                </tbody>
               </table>

              </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="showModal" class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Agrandir l'image</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body text-center">
          <img :src="getUrlApiForFiles('Usagers', selectedImage)" class="img-fluid" />
        </div>
      </div>
    </div>
  </div>
  <div v-if="showModal" class="modal-backdrop fade show"></div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import ApiService from "@/services/ApiService";
import { useRoute } from "vue-router";
import { error, getUrlApiForFiles } from "@/utils/utils";

export default defineComponent({
  name: "ViewEmplacement",
  setup() {
    const route = useRoute();
    const emplacement = ref<any | null>(null);

    const locataireMedia = computed(() => {
      return emplacement.value?.locataire?.medias?.filter(media => media.nomMedia && media.typeFichier === "Photo") || [];
    });

    const exploitantMedia = computed(() => {
      return emplacement.value?.exploitant?.medias?.filter(media => media.nomMedia && media.typeFichier === "Photo") || [];
    });

    function getEmplacement(id: string) {
      return ApiService.get("/emplacementdetail", id)
        .then(({ data }) => {
          emplacement.value = data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    const showModal = ref(false);
    const selectedImage = ref("");

    const openModal = (imageName: string) => {
      selectedImage.value = imageName;
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
      selectedImage.value = "";
    };

    onMounted(() => {
      const id = route.params.id as string;
      getEmplacement(id);
    });

    return { 
      emplacement, 
      locataireMedia, 
      exploitantMedia, 
      getUrlApiForFiles, 
      showModal, 
      selectedImage, 
      openModal, 
      closeModal 
    };
  },
});
</script>

